import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "@/lib/store";
import { formatINR } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { toggleWishlist, wishlist, addToCart } = useStore();
  const wished = wishlist.includes(product.id);
  const discount = product.original_price ? Math.round((1 - product.price / product.original_price) * 100) : 0;
  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative reveal"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <Link to={`/product/${product.slug}`} className="block relative bg-[#221712] overflow-hidden aspect-[4/5]">
        <img
          src={product.images?.[0]}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
          loading="lazy"
        />
        {product.images?.[1] && (
          <img
            src={product.images[1]}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700"
            loading="lazy"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#12100E]/70 via-transparent to-transparent opacity-60"/>
        {discount > 0 && (
          <span className="absolute top-3 left-3 text-[10px] tracking-[0.24em] uppercase bg-[#D4AF37] text-[#12100E] px-2 py-1 font-semibold">-{discount}%</span>
        )}
        {product.new_arrival && (
          <span className="absolute top-3 right-3 text-[10px] tracking-[0.24em] uppercase bg-[#12100E]/80 border border-[#D4AF37]/50 text-[#D4AF37] px-2 py-1">New</span>
        )}
      </Link>

      <button
        data-testid={`wishlist-${product.slug}`}
        onClick={(e) => { e.preventDefault(); toggleWishlist(product.id); }}
        className={`absolute top-3 ${product.new_arrival ? 'right-14' : 'right-3'} w-9 h-9 rounded-full bg-[#12100E]/70 backdrop-blur border border-[#D4AF37]/30 flex items-center justify-center transition hover:border-[#D4AF37]`}
      >
        <Heart size={15} className={wished ? "fill-[#D4AF37] text-[#D4AF37]" : "text-[#FAF8F5]"} />
      </button>

      <div className="pt-4 px-1">
        <div className="text-[10px] tracking-[0.24em] uppercase text-[#C2B29F]">{product.metal}{product.gemstone ? ` · ${product.gemstone}` : ''}</div>
        <Link to={`/product/${product.slug}`} className="block mt-1 font-serif-luxe text-lg text-[#FAF8F5] hover:text-[#D4AF37] transition leading-tight">{product.name}</Link>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-[#D4AF37] font-medium">{formatINR(product.price)}</span>
          {product.original_price && <span className="text-xs text-[#C2B29F] line-through">{formatINR(product.original_price)}</span>}
        </div>
        <button
          data-testid={`add-cart-${product.slug}`}
          onClick={() => addToCart(product)}
          className="mt-4 w-full text-[11px] tracking-[0.24em] uppercase border border-[#D4AF37]/40 text-[#FAF8F5] py-2.5 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition"
        >
          Add to Bag
        </button>
      </div>
    </div>
  );
};
